/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_Solution_ShortInputs */

const es_home_usecases_solution_short = /** @type {(inputs: Home_Usecases_Solution_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con Nexata`)
};

const en_home_usecases_solution_short = /** @type {(inputs: Home_Usecases_Solution_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With Nexata`)
};

/**
* | output |
* | --- |
* | "With Nexata" |
*
* @param {Home_Usecases_Solution_ShortInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_solution_short = /** @type {((inputs?: Home_Usecases_Solution_ShortInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_Solution_ShortInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_solution_short(inputs)
	return en_home_usecases_solution_short(inputs)
});
export { home_usecases_solution_short as "home.usecases.solution_short" }